export enum singleSelectPageConstants {
  NOT_IMPLEMENTED = 'singleSelectPage/NOT_IMPLEMENTED',
  IS_SCROLL_END = 'singleSelectPage/IS_SCROLL_END',
  SET_CHUNKED_OPTIONS = 'singleSelectPage/SET_CHUNKED_OPTIONS',
  SET_OPTIONS = 'singleSelectPage/SET_OPTIONS',
  UPDATE_CHUNKED_OPTIONS = 'singleSelectPage/UPDATE_CHUNKED_OPTIONS',
  SET_FILTERED_COMMON_OPTIONS = 'singleSelectPage/SET_FILTERED_COMMON_OPTIONS',
  SET_COMMON_OPTIONS = 'singleSelectPage/SET_COMMON_OPTIONS',
}
